import React from 'react'

const Textarea = ({onChange ,value, id, cols, rows, className, maxLength}) => {
  return (
    <div className='textarea-wrapper'><textarea
        id={id}
        value={value}
        onChange={onChange}
        className={`form-control-textarea ${className ? className :''}`}
        cols={cols}
        rows={rows}
        maxLength={maxLength && maxLength}
    ></textarea>
    {maxLength && <div className="textarea-wrapper-count">{value?.length ? Number(maxLength) - Number(value?.length) : maxLength}</div>}
</div>
  )
}

export default Textarea